import engine from 'store/src/store-engine'
import local_storage from 'store/storages/localStorage'
import session_storage from 'store/storages/sessionStorage'

export const storeLocal = engine.createStore([ local_storage ])
export const storeSession = engine.createStore([ session_storage ])